import vividCruisesSydney from "./pages/vivid-cruises-sydney";
import sydneyVividCruises from "./pages/sydney-vivid-cruises";
import vividCruiseSydney from "./pages/vivid-cruise-sydney";
import vividHarbourCruise from "./pages/vivid-harbour-cruise";
import vividSydneyBoatCruise from "./pages/vivid-sydney-boat-cruise";
import bestVividCruiseSydney from "./pages/best-vivid-cruise-sydney";
import vividSydneyHarbourCruise from "./pages/vivid-sydney-harbour-cruise";
import familyVividCruiseSydney from "./pages/family-vivid-cruise-sydney";
import privateVividCruiseSydney from "./pages/private-vivid-cruise-sydney";
import corporateVividCruiseSydney from "./pages/corporate-vivid-cruise-sydney";
import affordableVividCruiseSydney from "./pages/affordable-vivid-cruise-sydney";
import vividLightsCruiseSydney from "./pages/vivid-lights-cruise-sydney";
import sydneyHarbourVividCruise from "./pages/sydney-harbour-vivid-cruise";

export const ALL_PAGES = [
  vividCruisesSydney,
  sydneyVividCruises,
  vividCruiseSydney,
  vividHarbourCruise,
  vividSydneyBoatCruise,
  bestVividCruiseSydney,
  vividSydneyHarbourCruise,
  familyVividCruiseSydney,
  privateVividCruiseSydney,
  corporateVividCruiseSydney,
  affordableVividCruiseSydney,
  vividLightsCruiseSydney,
  sydneyHarbourVividCruise,
];

export const getPage = (slug) => ALL_PAGES.find((p) => p.slug === slug);
export const LANDING_LINKS = ALL_PAGES.map((p) => ({ slug: p.slug, label: p.navTitle }));
